(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-crosssell"]) return;
  try {
    
const productRecommendations = document.querySelector('[data-product-recommendations]');
const productId = productRecommendations.dataset.productId;
fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&limit=8&section_id=product-crosssell&intent=related`)
.then(response => response.text())
.then((text) => {
  const html = document.createElement('div');
  html.innerHTML = text;
  const recommendations = html.querySelector('[data-product-recommendations]');

  if (recommendations && recommendations.innerHTML.trim().length) {
    productRecommendations.innerHTML = recommendations.innerHTML;

    var productList = productRecommendations.querySelector('.ProductList');
    new window.ProductItemColorSwatch(productList);

    $(productList).find('.ProductItem').each(function() {
      var $item = $(this);
      var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
      handleColorSwitchImages($item, selectedColor);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
